module.exports = __webpack_public_path__ + "static/media/S3.97b92e02.jfif";


//////////////////
// WEBPACK FOOTER
// ./src/assests/images/S3.jfif
// module id = 124
// module chunks = 0